import { render, staticRenderFns } from "./NadaljnjiUkrepiIP.vue?vue&type=template&id=f818c05a&scoped=true&"
import script from "./NadaljnjiUkrepiIP.vue?vue&type=script&lang=js&"
export * from "./NadaljnjiUkrepiIP.vue?vue&type=script&lang=js&"
import style0 from "./NadaljnjiUkrepiIP.vue?vue&type=style&index=0&id=f818c05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f818c05a",
  null
  
)

export default component.exports